import React, { useRef } from 'react'
import { useFormContext } from 'react-hook-form'
import { useLocation } from 'react-router-dom'
import {
  InputsWrapper,
  RowTitle,
  StyledInput,
} from '../styles/ParametersForm.styles'
import { StandardInput } from '../../../../ui_reusable/StandardInputs'
import CustomIcons from '../../../../ui_reusable/CustomIcons'
import theme from '../../../../../styles/theme'
import { ROUTED_REPORT_MODES } from '../../../../reports/types/ReportTypes'
import {
  ImpactArtifactRequest,
  OptimizeArtifactRequest,
} from '@/api/generated/models'

const ModelNameEdit = () => {
  const { register, watch } = useFormContext<
    OptimizeArtifactRequest | ImpactArtifactRequest
  >()
  const location = useLocation()
  const nameInputRef = useRef<HTMLInputElement | null>(null)
  const isEditMode = location.state?.mode === ROUTED_REPORT_MODES.EDIT_MODEL
  const modelName = watch('name')

  const handleNameEditFocus = () => {
    if (nameInputRef.current) {
      nameInputRef.current.focus()
    }
  }

  if (location.state?.mode !== ROUTED_REPORT_MODES.EDIT_MODEL) {
    return null
  }

  return (
    <>
      <RowTitle>Model Name:</RowTitle>
      <InputsWrapper>
        <StyledInput>
          {isEditMode ? (
            <StandardInput
              id="model_name"
              {...register('name')}
              ref={(el) => {
                register('name').ref(el)
                nameInputRef.current = el
              }}
              style={{ width: '33rem' }}
            />
          ) : (
            <StandardInput
              id="model_name"
              value={modelName || ''}
              readOnly
              disabled
              style={{ width: '33rem', opacity: 0.7 }}
            />
          )}
        </StyledInput>
        {isEditMode && (
          <CustomIcons.PenIcon
            color={theme.colors.fadedText}
            size="xs"
            onClick={handleNameEditFocus}
          />
        )}
      </InputsWrapper>
    </>
  )
}

export default ModelNameEdit
